export const formatMyBookingTime = (value: string | undefined) => {
  if (!!value) {
    const result = value?.split(":");
    result?.pop();
    return result?.join(".");
  }
  return null;
};
